const FREQUENCY_OPTIONS = {
  Daily: 86400,
  Weekly: 604800,
  Monthly: 2629746,
  Annually: 31556952,
};

export type FrequencySelectValue = string | null | undefined;

export const buildFrequencyOptions = (defaultSeconds?: number | null) => {
  const defaultKey =
    defaultSeconds != null
      ? Object.entries(FREQUENCY_OPTIONS).find(
          ([, v]) => v === defaultSeconds,
        )?.[0]
      : undefined;

  const teamDefaultLabel = defaultKey
    ? `Team Default (${defaultKey})`
    : "Team Default";

  const options = Object.entries(FREQUENCY_OPTIONS).map(([label, seconds]) => ({
    label,
    value: seconds.toString(),
  }));

  return [{ label: teamDefaultLabel, value: "null" }, ...options];
};

/**
 * "null" / null / undefined => null
 * other => number
 */
export const parseFrequencyOverride = (
  val: FrequencySelectValue,
): number | null => {
  if (val == null || val === "null" || val === "") return null;
  const n = Number(val);

  return Number.isFinite(n) && n > 0 ? n : null;
};

export const toFrequencySelectValue = (override?: number | null): string =>
  override == null ? "null" : String(override);
